// eslint-disable-next-line
import React from "react";
import ReactDOM from "react-dom";
import "./reset.css";
import Home from "./components/Home/index";

ReactDOM.render(
  <React.StrictMode>
    <Home></Home>
  </React.StrictMode>,
  document.getElementById("root")
);
